import { IApplicationState } from '../../types/redux';

export const selectFormattedTitle = (state: IApplicationState): string => {
  return 'Рейтинг агентств недвижимости ' + state.filters.region.titleForRender;
};
